{
  "name": "purple_fit_booking",
  "version": "1.0.61",
  "scripts": {
    "ng": "ng",
    "add-customer": "node node_modules/@purple-lib/purple-utilities/scripts/add-new-customer.js",
    "generate-favicon": "node node_modules/@purple-lib/purple-utilities/scripts/generate-favicon.mjs -n SelSystem -c ses -h 0E4186",
    "export-translations": "node node_modules/@purple-lib/purple-utilities/scripts/extract-purple-translations.js --p='backoffice' --output=\".\"",
    "clean-api-models": "rimraf src/core-modules/sdk",
    "clean-node-modules": "rimraf node_modules && rimraf package-lock.json",
    "refresh-node-modules": "npm run clean-node-modules && npm i --loglevel verbose",
    "generate-api-models": "openapi-generator-cli generate -i http://localhost:5010/swagger/vPurpleFit/swagger.json -g typescript-angular -o ./src/core-modules/sdk --skip-validate-spec --additional-properties=supportsES6=true",
    "update-api-models": "npm run clean-api-models && npm run generate-api-models",
    "update-purple-libs": "ncu --filter \"@purple-lib/*\" -u && npm i",
    "start-purplefit": "node tools/set-local-ip.js &&  ng serve --configuration purplefit-local",
    "start-mot": "node tools/set-local-ip.js &&  ng serve --configuration mot-local",
    "build-purplefit": "ng build --configuration purplefit-production",
    "build-purplefit-dev": "ng build --configuration purplefit-development",
    "build-mot": "ng build --configuration mot-production"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "20.3.3",
    "@angular/common": "20.3.3",
    "@angular/compiler": "20.3.3",
    "@angular/core": "20.3.3",
    "@angular/fire": "^20.0.1",
    "@angular/forms": "20.3.3",
    "@angular/platform-browser": "20.3.3",
    "@angular/platform-browser-dynamic": "20.3.3",
    "@angular/router": "20.3.3",
    "@ant-design/icons-angular": "^20.0.0",
    "@auth0/angular-jwt": "^5.2.0",
    "@ckeditor/ckeditor5-angular": "^10.0.0",
    "@ngu/carousel": "^20.0.1",
    "@purple-lib/purple-addresses-core": "^20.3.23",
    "@purple-lib/purple-admin-tool": "^20.3.15",
    "@purple-lib/purple-api-token": "^20.3.23",
    "@purple-lib/purple-edit-medias": "^20.3.25",
    "@purple-lib/purple-edit-translations": "^20.3.25",
    "@purple-lib/purple-medias-core": "^20.3.25",
    "@purple-lib/purple-notifications-core": "^20.3.23",
    "@purple-lib/purple-policies-core": "^20.3.25",
    "@purple-lib/purple-styles": "^20.3.22",
    "@purple-lib/purple-translations-core": "^20.3.23",
    "@purple-lib/purple-ui-widgets": "^20.3.25",
    "@purple-lib/purple-users-core": "^20.3.26",
    "@purple-lib/purple-utilities": "^20.3.23",
    "@types/leaflet": "^1.9.21",
    "@types/lz-string": "^1.5.0",
    "angular-calendar": "^0.32.0",
    "angular-draggable-droppable": "^9.0.1",
    "angular-resizable-element": "^8.0.1",
    "ckeditor5": "^47.4.0",
    "crypto-js": "^4.2.0",
    "date-fns": "^4.1.0",
    "date-fns-tz": "^3.2.0",
    "hammerjs": "^2.0.8",
    "install": "^0.13.0",
    "lottie-web": "^5.13.0",
    "lz-string": "^1.5.0",
    "monaco-editor": "^0.54.0",
    "ng-zorro-antd": "^20.3.1",
    "ngx-image-cropper": "^9.1.5",
    "ngx-lottie": "^20.0.0",
    "npm": "^11.6.1",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "20.3.5",
    "@angular/cli": "20.3.5",
    "@angular/compiler-cli": "20.3.3",
    "@openapitools/openapi-generator-cli": "^2.25.0",
    "@purple-lib/purple-docs": "^20.3.23",
    "@types/jasmine": "~5.1.9",
    "jasmine-core": "~5.12.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "less": "^4.4.2",
    "typescript": "~5.9.3"
  }
}
